import EditFormToolbarCoreUI from './EditFormToolbarCoreUI';

export default EditFormToolbarCoreUI;
